import React, { Component } from 'react';
import * as rmd from 'material-ui';

const PROVIDERS = ['comeon', 'betbull'];

class OddsProviderPicker extends Component {
    static defaultProps = {};

    constructor(props, context) {
        super(props, context);

        this.state = {
            value: props[props.propKey],
        };
    }

    renderOption(value) {
        return <rmd.MenuItem key={value} value={value} primaryText={value} />;
    }

    handleChange = (e, key, payload) => {
        this.props.onChange(this.props.propKey, payload);
        this.setState({ value: payload });
    };

    render() {
        return (
            <div>
                <rmd.SelectField
                    style={{ width: '100%' }}
                    value={this.state.value}
                    floatingLabelText={this.props.label}
                    floatingLabelFixed
                    onChange={this.handleChange}
                >
                    {PROVIDERS.map(this.renderOption)}
                </rmd.SelectField>
            </div>
        );
    }
}

export default OddsProviderPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/OddsProviderPicker.js
 **/